import './hotspot.sass'
export { default } from './Hotspot'
